import { IconPrinter, IconProps } from '@tabler/icons-react';
import { ActionIcon } from '@zorro/design-system/v2/ActionIcon';
import { Icon, brand } from '@zorro/web/design-system';

type Props = {
  onClick: () => void;
  withBorder?: boolean;
  size?: IconProps['size'];
  className?: string;
};

export const PrintButton = ({
  onClick,
  withBorder = true,
  size,
  className,
}: Props) => {
  return (
    <ActionIcon
      bd={withBorder ? `1px solid ${brand.zorroGray200}` : undefined}
      size="lg"
      onClick={onClick}
      className={className}
    >
      <Icon icon={IconPrinter} size={size} />
    </ActionIcon>
  );
};
